import { ai as m, b as l, aj as d, u as t, ak as u, al as p, am as x, an as h } from "./index-D75-8-ei.js";
const b = {
  prefix: "fab",
  iconName: "creative-commons",
  icon: [496, 512, [], "f25e", "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"]
};
function v({
  licenseId: s,
  className: r
}) {
  const a = m().templatePlugins.solution, [i, n] = l.useState(!1), { licenses: o } = l.useContext(d);
  return o ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsxs(
      "button",
      {
        className: u(
          "absolute -top-0.5 right-12 z-20",
          "serlo-button-round serlo-button-edit-secondary serlo-tooltip-trigger mr-2",
          r
        ),
        onMouseDown: (e) => {
          e.preventDefault(), e.stopPropagation();
        },
        onClick: () => n(!0),
        children: [
          /* @__PURE__ */ t.jsx(p, { text: a.changeLicense }),
          /* @__PURE__ */ t.jsx(x, { icon: b })
        ]
      }
    ),
    /* @__PURE__ */ t.jsx(
      h,
      {
        isOpen: i,
        setIsOpen: n,
        className: "top-8 max-w-xl translate-y-0 sm:top-24",
        title: a.changeLicense,
        extraTitleClassName: "serlo-h3 mt-4",
        children: /* @__PURE__ */ t.jsx("div", { className: "mx-side mb-3", children: /* @__PURE__ */ t.jsx(
          "select",
          {
            className: "serlo-button-learner-secondary serlo-input-font-reset max-w-md",
            onChange: (e) => {
              s.defined ? s.set(parseInt(e.target.value)) : s.create(parseInt(e.target.value));
            },
            value: s.defined ? s.value : void 0,
            children: o.map(({ id: e, title: c }) => /* @__PURE__ */ t.jsxs("option", { className: "bg-brand-200 text-brand", value: e, children: [
              e,
              " ",
              c
            ] }, e))
          }
        ) })
      }
    )
  ] }) : null;
}
export {
  v as SerloLicenseChooser
};
